import React from 'react';
import classnames from 'classnames';
import './Button.css'

export default ({ className, text, value }) => (
    <button data-button={value} className={classnames(className, 'button')}>
        {text}
    </button>
);